import { useStudentSubmittedSurveysQuery } from 'core/graphql';

import { ISubmittedSurvey, transformSubmittedSurveys } from './transform';

interface IUseMySubmittedSurveys {
  surveys: ISubmittedSurvey[];
  loading: boolean;
  error: string;
  refetch: () => void;
}

/**
 * Spec 0027 — the surveys this student has already submitted, newest first.
 *
 * The student is derived from the token on the server; there is no `studentId`
 * argument to pass, and that is deliberate — an id argument here was the IDOR in
 * `pendingSurveysCount`.
 *
 * `skip` is the caller's job: the archive is only worth fetching once the page is
 * actually shown to a student, since it carries every answer body.
 */
export const useMySubmittedSurveys = (skip = false): IUseMySubmittedSurveys => {
  const { data, loading, error, refetch } = useStudentSubmittedSurveysQuery({
    skip,
    fetchPolicy: 'cache-and-network',
  });

  return {
    surveys: transformSubmittedSurveys(data),
    loading,
    error: error?.message || '',
    refetch,
  };
};
